module.exports = __webpack_public_path__ + "img/Gruppe 2466.0a14ebd5.svg";